import {useContext, useEffect} from 'react'

import { KitDocumentoModalFormWrapper} from './KitDocumentoModalFormWrapper'
import { KitDocumentoModalHeader } from './KitDocumentoModalHeader'
import { PartnerContext } from '../PartnerContexts'
import { PartnerEditShowContext } from '../partner-edit/PartnerEditShowContexts'

const KitDocumentoModal = () => {

  const {showKitDocumentoModal} = useContext(PartnerEditShowContext)

  return (
    <>
      {showKitDocumentoModal && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-lg'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <KitDocumentoModalHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <KitDocumentoModalFormWrapper />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {KitDocumentoModal}
